const APP_LOGIN_URL = 'billposterexpo://login';

/** No session or recovery credentials are passed to the app. */
export function mobileAppLoginUrl(userAgent: string, origin: string): string {
  if (!/Android/i.test(userAgent)) return APP_LOGIN_URL;
  const fallback = encodeURIComponent(`${origin}/auth/mobile-ready`);
  return `intent://login#Intent;scheme=billposterexpo;package=com.keith_reaction.billposterexpo;S.browser_fallback_url=${fallback};end`;
}
